import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  x: "0",
  y: "0",
  version: "1.1",
  viewBox: "0 0 42.5 42.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m429.4 593.8 25.1 25.1M454.5 593.8l-25.1 25.1",
      class: "st0"
    }, null, -1),
    _createElementVNode("path", { d: "m35.9 10.7-1.4-1.4-11.9 11.8L10.8 9.3l-1.4 1.4 11.8 11.9L9.4 34.4l1.4 1.4L22.6 24l11.9 11.8 1.4-1.4-11.8-11.8z" }, null, -1)
  ])))
}
export default { render: render }